import styled from 'styled-components/macro'

import { FetchMoreFn, Product } from '../../types'
import { getColorCostElementWidth, getColorSizeElementWidth } from '../../utils'
import { LoadAllProducts } from './components/LoadAllProducts/LoadAllProducts'
import { ProductItem } from './components/ProductItem/ProductItem'

export function ProductsList({ products, totalCount, onLoadAllProds }: Props) {
  const colorCostElementWidth = getColorCostElementWidth(products)
  const colorSizeElementWidth = getColorSizeElementWidth(products)

  return (
    <>
      <StyledList
        $colorCostWidth={colorCostElementWidth}
        $colorSizeWidth={colorSizeElementWidth}
      >
        {products.map((prod) => (
          <ProductItem key={prod.id} product={prod} />
        ))}
      </StyledList>
      <LoadAllProducts
        onLoadAllProds={onLoadAllProds}
        total={totalCount}
        count={products.length}
      />
    </>
  )
}

type Props = {
  products: Product[]
  totalCount: number
  onLoadAllProds: FetchMoreFn
}

const StyledList = styled.ul<{
  $colorCostWidth: ReturnType<typeof getColorCostElementWidth>
  $colorSizeWidth: ReturnType<typeof getColorSizeElementWidth>
}>`
  list-style: none;
  padding: 0;
  margin: 0;

  div[data-column-name='qty-and-cost'] {
    & .cost {
      width: ${({ $colorCostWidth }) => $colorCostWidth};
    }
  }

  .size-item {
    width: ${({ $colorSizeWidth }) => $colorSizeWidth};
  }
`
